import log from 'loglevel';
import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { ClickAway } from '../../Utils';

import './style.scss';

import closeIcon from 'assets/close-icon.svg';

export interface InfoPopupProps {
    isShowing: boolean;
    text: string;
    hasCloseButton?: boolean;
    onHide?: () => any;
    clickAwayRootId?: string;
    variant?: string;
    horizontalAlign?: string;
    verticalAlign?: string;
}

export const InfoPopup: React.FC<InfoPopupProps> = ({
    isShowing,
    hasCloseButton,
    onHide,
    text,
    clickAwayRootId,
    variant,
    horizontalAlign,
    verticalAlign,
}: InfoPopupProps) => {
    return isShowing ? (
        <ClickAway onClickAway={() => onHide && onHide()} rootId={clickAwayRootId}>
            <div
                className={`rw-info-popup rw-info-popup-variant-${variant || 'default'} rw-info-popup-halign-${horizontalAlign || 'left'} rw-info-popup-valign-${verticalAlign || 'top'}`}
            >
                {hasCloseButton ? (
                    <button
                        className="rw-info-popup-close"
                        onClick={(e) => {
                            e.stopPropagation();
                            onHide && onHide();
                        }}
                    >
                        <img src={closeIcon} />
                    </button>
                ) : null}
                <div
                    className="rw-info-popup-body"
                    onClick={(e) => {
                        e.stopPropagation();
                        onHide && onHide();
                    }}
                >
                    <ReactMarkdown>{text}</ReactMarkdown>
                </div>
            </div>
        </ClickAway>
    ) : null;
};
